<template>
  <v-container>
    <p class="center">
      <img :src="src" class="img" :style="`max-width: ${width}px`">
    </p>
    <h3 class="center bold-text">{{firstLine}}</h3>
    <h5 class="center">{{secondLine}}</h5>
    <h2 class="center" v-if="showButton">
      <v-btn round color="primary" class="create-button black--text" @click="click()">Tạo lịch mới</v-btn>
    </h2>
  </v-container>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    firstLine: {
      type: String,
      default: ''
    },
    secondLine: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 250
    },
    onClick: {
      type: Function,
      default: _ => console.log('onClick')
    },
    showButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click () {
      this.onClick();
    }
  }
};
</script>
<style scoped>
.bold-text {
  font-weight: bold;
}
.img {
  padding-top: 10%;
}
.center {
  text-align: center;
}
.create-button {
  margin-top: 16px;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Blank.vue